import React, { useState, useEffect, useContext } from 'react';
/*
type ExamCheckProps = {
    record: ExamRightAnswer[]
}*/

type MyDataProps = {
    title: string
    rightAns: ExamAnswer | null
    userAns: ExamAnswer,
    answersList?: ExamAnswer[]
}

import { ExamContext } from '../context/ExamContext'
import { HibModal } from '../course/HibModal';
import { Yes } from '../course/SVG';

export default (/*props: ExamCheckProps*/) => {

    const ec = useContext(ExamContext)

    const [MyData, setMyData] = useState<MyDataProps[]>()
    const [open, setOpen] = useState<boolean>(false)

    useEffect(() => {

        const tempData: MyDataProps[] = []

        
        ec.record.map((ans: ExamRightAnswer, index: number) => {
            let _t: MyDataProps = { ...ans }
            _t.answersList = ec.examData[index].answersList
            tempData.push(_t)
        })
        setMyData(tempData)
        return
    }, [ec.record])


    return (
        <>
            <button 
                className='hibBtn main' 
                onClick={()=>{ setOpen(!open) }}
                disabled={ MyData?.length?false:true}
            >修改已作答的試題答案 : {MyData?.length}</button>
            <HibModal
                title="修改已作答的試題答案"
                showCross
                className='large'
                type='photo'
                show={open}
                cancel={()=>{setOpen(false)}}
                children={

                    <div className='ExamCheck' style={{ width: "100%" }}>    
                        {
                            MyData?.map((item: MyDataProps, index: number) => {
                                return (
                                    <div className='myAnswerCard' key={"title_" + index}>
                                        <p className='ansTitle'>{index+1}. {item.title} </p>
                                        <div>
                                            {
                                                item.answersList?.map((ans: ExamAnswer, index2: number) => {
                                                    return (
                                                        <div 
                                                            className={"hibBtn ansBtn "+ (item.userAns?.ItemID == ans.ItemID ? "active":"") } 
                                                            key={"ansList_" + index2} style={{ display: "flex" }}
                                                            onClick={() => {
                                                                ec.updateRecord(index, ans)
                                                            }}
                                                        >
                                                            <span style={{ flexBasis: 20 }}>
                                                                {
                                                                    item.userAns?.ItemID == ans.ItemID && 
                                                                    <Yes/>
                                                                }
                                                            </span>

                                                            <span style={{paddingLeft:10}}>
                                                                {ans.ItemTitle}
                                                            </span>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {/*
                ec.examData.map((item: ExamUnit, index: number) => {
                    return (
                        <div key={"question-" + index}>
                            <div className="title">
                                <span>
                                    {index + 1}.{item.question}
                                </span>
                            </div>
                            <div style={{marginBottom:30}}>
                                {
                                    item.answersList.map((ans:ExamAnswer, index2:number)=>{
                                        return(
                                            <button className='hibBtn' style={{display:"flex"}}> 
                                                <span>{index2+1}.</span>
                                                <div style={{whiteSpace:"break-spaces",textAlign:"left"}}>{ans.ItemTitle}</div>
                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                })
                */
                        }

                    </div>
                }
            />
        </>
    )
}